<template>
    <!-- Admin → Property (/admin/property): qué departamentos salen en el
         formulario público de huéspedes (/property-huesped) y a qué correo llega
         cada autorización. Mismo diseño que Usuarios / Cupones / Links
         (bkCuenta + cuentaMenu + usuariosAdmin.css) y propertyAdmin.css (pa-).
         Pedidos de siempre (PropertyAdminController):
           GET    admin/property/accommodations
           GET    admin/property/accommodations/lookup/{id}
           POST   admin/property/accommodations        {idalojamiento, comuna, correo_notificacion}
           PUT    admin/property/accommodations/{id}   {comuna?, correo_notificacion?, activo?}
           DELETE admin/property/accommodations/{id}
           GET    admin/property/guests -->
    <div class="pa-page">
        <div class="bk us pa">
            <aside class="bk-side us-side">
                <router-link :to="{ name: 'admin' }" class="us-back">
                    <span aria-hidden="true" v-html="IC.back"></span>{{ $t('admin_property.back') }}
                </router-link>
                <h1 class="bk-title">{{ $t('admin_property.title_a') }} <span class="bk-grad">{{ $t('admin_property.title_b') }}</span></h1>
                <p class="bk-subtitle">{{ $t('admin_property.sub') }}</p>

                <div class="us-stats" aria-live="polite">
                    <div class="us-stat"><span class="us-stat-n">{{ numero(items.length) }}</span><span class="us-stat-k">{{ $t('admin_property.stat.aloj') }}</span></div>
                    <div class="us-stat"><span class="us-stat-n">{{ numero(activos) }}</span><span class="us-stat-k">{{ $t('admin_property.stat.on') }}</span></div>
                    <div class="us-stat"><span class="us-stat-n">{{ numero(guests.length) }}</span><span class="us-stat-k">{{ $t('admin_property.stat.guests') }}</span></div>
                    <div class="us-stat"><span class="us-stat-n pa-ok">{{ numero(enviados) }}</span><span class="us-stat-k">{{ $t('admin_property.stat.sent') }}</span></div>
                </div>

                <div class="pa-public">
                    <a class="bk-btn bk-btn--ghost" :href="publicUrl" target="_blank" rel="noopener"><span aria-hidden="true" v-html="IC.ext"></span>{{ $t('admin_property.public') }}</a>
                    <button type="button" class="bk-btn bk-btn--ghost pa-icon-btn" :aria-label="$t('admin_property.copy_public')" :title="$t('admin_property.copy_public')" @click="copiar(publicUrl)"><span aria-hidden="true" v-html="IC.copy"></span></button>
                </div>
            </aside>

            <section class="us-main pa-main">
                <nav class="bk-tabs pa-tabs" :aria-label="$t('admin_property.tabs.label')">
                    <button v-for="t in TABS" :key="t" type="button" :class="['bk-tab', { 'is-active': tab === t }]" :aria-pressed="String(tab === t)" @click="tab = t">
                        {{ $t(`admin_property.tabs.${t}`) }}<span class="pa-tab-n">{{ numero(t === 'aloj' ? items.length : guests.length) }}</span>
                    </button>
                </nav>

                <div v-if="!cargado" class="pa-loading"><HyFLoader variant="inline" /></div>
                <div v-else-if="errorCarga" class="us-empty">
                    <h3>{{ $t('admin_property.toast.load') }}</h3>
                    <button type="button" class="bk-btn bk-btn--ghost" @click="cargarTodo">{{ $t('admin_property.retry') }}</button>
                </div>

                <!-- ═════ Alojamientos ═════ -->
                <template v-else-if="tab === 'aloj'">
                    <form class="pa-card" novalidate @submit.prevent="buscar">
                        <h2 class="pa-h">{{ $t('admin_property.add.title') }}</h2>
                        <p class="pa-lead">{{ $t('admin_property.add.lead') }}</p>
                        <div class="pa-lookup">
                            <label class="pa-id-in">
                                <span class="us-sr">{{ $t('admin_property.add.id') }}</span>
                                <span aria-hidden="true">#</span>
                                <input v-model="nuevo.id" type="text" inputmode="numeric" autocomplete="off" :placeholder="$t('admin_property.add.id')" @input="nuevo.id = nuevo.id.replace(/\D/g, ''); lookup = null" />
                            </label>
                            <button type="submit" class="bk-btn bk-btn--primary" :disabled="!nuevo.id || buscando">
                                <span v-if="buscando" class="bk-spinner"></span>{{ $t(buscando ? 'admin_property.add.searching' : 'admin_property.add.search') }}
                            </button>
                        </div>

                        <p v-if="lookup && !lookup.exists" class="us-note us-note--warn" role="alert"><span aria-hidden="true" v-html="IC.warn"></span><span>{{ $t('admin_property.add.not_found', { id: lookup.id }) }}</span></p>
                        <p v-else-if="lookup && lookup.ya_configurado" class="us-note" role="status"><span aria-hidden="true" v-html="IC.info"></span><span>{{ $t('admin_property.add.already', { id: lookup.id }) }}</span></p>
                    </form>

                    <form v-if="lookup && lookup.exists && !lookup.ya_configurado" class="pa-card pa-found" novalidate @submit.prevent="agregar">
                        <div class="pa-found-head">
                            <span class="pa-pill">#{{ lookup.id }}</span>
                            <span class="pa-badge pa-badge--on">{{ $t('admin_property.add.found') }}</span>
                        </div>
                        <dl class="pa-kv">
                            <div><dt>{{ $t('admin_property.add.depto') }}</dt><dd>{{ lookup.numero || '—' }}</dd></div>
                            <div><dt>{{ $t('admin_property.add.address') }}</dt><dd>{{ lookup.direccion || '—' }}</dd></div>
                        </dl>
                        <div class="us-g2">
                            <label :class="['us-field', { 'is-invalid': errAdd.comuna }]">
                                <span class="us-field-l">{{ $t('admin_property.add.comuna') }}</span>
                                <input ref="comunaIn" v-model.trim="nuevo.comuna" type="text" maxlength="120" :placeholder="$t('admin_property.add.comuna_ph')" @input="errAdd.comuna = ''" />
                                <span v-if="errAdd.comuna" class="us-field-e">{{ errAdd.comuna }}</span>
                            </label>
                            <label :class="['us-field', { 'is-invalid': errAdd.correo }]">
                                <span class="us-field-l">{{ $t('admin_property.add.mail') }}</span>
                                <input v-model.trim="nuevo.correo" type="email" maxlength="200" placeholder="recepcion@edificio.cl" @input="errAdd.correo = ''" />
                                <span v-if="errAdd.correo" class="us-field-e">{{ errAdd.correo }}</span>
                                <span v-else class="us-field-h">{{ $t('admin_property.add.mail_h') }}</span>
                            </label>
                        </div>
                        <div class="pa-actions-end">
                            <button type="submit" class="bk-btn bk-btn--primary" :disabled="guardando">
                                <span v-if="guardando" class="bk-spinner"></span><span v-else aria-hidden="true" v-html="IC.plus"></span>{{ $t(guardando ? 'admin_property.add.saving' : 'admin_property.add.submit') }}
                            </button>
                        </div>
                    </form>

                    <h2 class="pa-h pa-list-h">{{ $t('admin_property.list.title') }}</h2>
                    <div v-if="!items.length" class="us-empty">
                        <h3>{{ $t('admin_property.list.none_t') }}</h3>
                        <p>{{ $t('admin_property.list.none_p') }}</p>
                    </div>
                    <ul v-else class="pa-list">
                        <li v-for="it in items" :key="it.idproperty_alojamiento" :data-id="it.idproperty_alojamiento" :class="['pa-item', { 'is-off': !activo(it), 'is-editing': editId === it.idproperty_alojamiento }]">
                            <div class="pa-item-main">
                                <div class="pa-item-top">
                                    <span class="pa-pill">#{{ it.alojamiento_idalojamiento }}</span>
                                    <b class="pa-item-t">{{ it.numero ? $t('admin_property.list.depto', { n: it.numero }) : $t('admin_property.list.no_depto') }}</b>
                                    <span :class="['pa-badge', activo(it) ? 'pa-badge--on' : 'pa-badge--off']">{{ $t(activo(it) ? 'admin_property.list.active' : 'admin_property.list.inactive') }}</span>
                                    <span class="pa-badge">{{ $tc('admin_property.list.guests', huespedesDe(it), { n: huespedesDe(it) }) }}</span>
                                </div>
                                <p class="pa-item-addr">{{ it.direccion || '—' }}</p>

                                <p v-if="editId !== it.idproperty_alojamiento" class="pa-item-meta">
                                    <span><span aria-hidden="true" v-html="IC.pin"></span>{{ it.comuna || '—' }}</span>
                                    <span><span aria-hidden="true" v-html="IC.mail"></span>{{ it.correo_notificacion || '—' }}</span>
                                </p>
                                <form v-else class="pa-edit" novalidate @submit.prevent="guardarEdicion(it)" @keydown.esc.prevent="cancelarEdicion">
                                    <div class="us-g2">
                                        <label :class="['us-field', { 'is-invalid': errEdit.comuna }]">
                                            <span class="us-field-l">{{ $t('admin_property.add.comuna') }}</span>
                                            <input ref="editIn" v-model.trim="edit.comuna" type="text" maxlength="120" @input="errEdit.comuna = ''" />
                                            <span v-if="errEdit.comuna" class="us-field-e">{{ errEdit.comuna }}</span>
                                        </label>
                                        <label :class="['us-field', { 'is-invalid': errEdit.correo }]">
                                            <span class="us-field-l">{{ $t('admin_property.add.mail') }}</span>
                                            <input v-model.trim="edit.correo" type="email" maxlength="200" @input="errEdit.correo = ''" />
                                            <span v-if="errEdit.correo" class="us-field-e">{{ errEdit.correo }}</span>
                                        </label>
                                    </div>
                                    <div class="pa-actions-end">
                                        <button type="button" class="bk-btn bk-btn--ghost" :disabled="guardandoEdit" @click="cancelarEdicion">{{ $t('admin_property.list.cancel') }}</button>
                                        <button type="submit" class="bk-btn bk-btn--primary" :disabled="guardandoEdit"><span v-if="guardandoEdit" class="bk-spinner"></span>{{ $t('admin_property.list.save') }}</button>
                                    </div>
                                </form>
                            </div>
                            <div v-if="editId !== it.idproperty_alojamiento" class="pa-item-actions">
                                <button
                                    type="button"
                                    role="switch"
                                    :class="['pa-switch', { 'is-on': activo(it) }]"
                                    :aria-checked="String(activo(it))"
                                    :aria-label="$t(activo(it) ? 'admin_property.list.toggle_off' : 'admin_property.list.toggle_on', { id: it.alojamiento_idalojamiento })"
                                    :disabled="cambiando === it.idproperty_alojamiento"
                                    @click="alternar(it)"
                                ><span class="pa-switch-dot"></span></button>
                                <button type="button" class="bk-btn bk-btn--ghost" @click="empezarEdicion(it)"><span aria-hidden="true" v-html="IC.edit"></span>{{ $t('admin_property.list.edit') }}</button>
                                <button type="button" class="bk-btn bk-btn--ghost pa-icon-btn pa-del" :aria-label="$t('admin_property.list.delete', { id: it.alojamiento_idalojamiento })" :title="$t('admin_property.list.delete', { id: it.alojamiento_idalojamiento })" @click="quitar(it)"><span aria-hidden="true" v-html="IC.trash"></span></button>
                            </div>
                        </li>
                    </ul>
                </template>

                <!-- ═════ Huéspedes ═════ -->
                <template v-else>
                    <div class="us-toolbar">
                        <div class="pa-toolbar-top">
                            <label class="us-search">
                                <span aria-hidden="true" v-html="IC.search"></span>
                                <span class="us-sr">{{ $t('admin_property.g.search_label') }}</span>
                                <input v-model="q" type="search" autocomplete="off" :placeholder="$t('admin_property.g.search_ph')" @input="pagina = 1" />
                            </label>
                            <button type="button" class="bk-btn bk-btn--ghost pa-refresh" :disabled="cargandoGuests" @click="refrescarHuespedes">
                                <span v-if="cargandoGuests" class="bk-spinner"></span><span v-else aria-hidden="true" v-html="IC.sync"></span>{{ $t('admin_property.g.refresh') }}
                            </button>
                        </div>
                        <div class="us-seg" role="group" :aria-label="$t('admin_property.g.search_label')">
                            <button v-for="f in FILTROS" :key="f || 'all'" type="button" :class="{ 'is-on': filtro === f }" :aria-pressed="String(filtro === f)" @click="filtro = f; pagina = 1">
                                {{ $t(`admin_property.g.${f || 'all'}`) }}<span>{{ numero(f === 'sent' ? enviados : f === 'pending' ? guests.length - enviados : guests.length) }}</span>
                            </button>
                        </div>
                    </div>

                    <p v-if="guests.length && (q || filtro)" class="pa-count" aria-live="polite">
                        {{ $tc('admin_property.g.results', guestsFiltrados.length, { n: numero(guestsFiltrados.length) }) }}
                        <button type="button" class="us-link" @click="q = ''; filtro = ''; pagina = 1">{{ $t('admin_property.g.clear') }}</button>
                    </p>

                    <div v-if="!guests.length" class="us-empty">
                        <h3>{{ $t('admin_property.g.none_t') }}</h3>
                        <p>{{ $t('admin_property.g.none_p') }}</p>
                    </div>
                    <div v-else-if="!guestsFiltrados.length" class="us-empty">
                        <h3>{{ $t('admin_property.g.empty_t') }}</h3>
                        <p>{{ $t('admin_property.g.empty_p') }}</p>
                    </div>
                    <ul v-else class="pa-list">
                        <li v-for="g in guestsPagina" :key="g.idproperty_guest" class="pa-guest">
                            <span class="pa-av" aria-hidden="true">{{ iniciales(g) }}</span>
                            <div class="pa-guest-main">
                                <div class="pa-item-top">
                                    <b class="pa-item-t">{{ `${g.nombre || ''} ${g.apellido || ''}`.trim() || '—' }}</b>
                                    <span :class="['pa-badge', enviado(g) ? 'pa-badge--on' : 'pa-badge--wait']">{{ $t(enviado(g) ? 'admin_property.g.status_sent' : 'admin_property.g.status_pending') }}</span>
                                </div>
                                <p class="pa-item-meta">
                                    <span><span aria-hidden="true" v-html="IC.id"></span><span class="us-mono">{{ g.rut_pasaporte || '—' }}</span></span>
                                    <span v-if="g.correo"><span aria-hidden="true" v-html="IC.mail"></span>{{ g.correo }}</span>
                                    <span v-if="g.telefono"><span aria-hidden="true" v-html="IC.tel"></span>{{ g.telefono }}</span>
                                </p>
                                <p class="pa-guest-stay">
                                    <span class="pa-pill">{{ g.numero ? $t('admin_property.g.depto', { n: g.numero }) : '—' }}</span>
                                    <span>{{ fecha(g.fecha_ingreso) }} → {{ fecha(g.fecha_salida) }}</span>
                                    <span class="pa-dim">{{ $tc('admin_property.g.nights', noches(g), { n: noches(g) }) }}</span>
                                    <span v-if="g.created_at" class="pa-dim">· {{ $t('admin_property.g.registered', { d: fecha(g.created_at) }) }}</span>
                                </p>
                            </div>
                        </li>
                    </ul>
                    <BkPaginacion :actual="pagina" :ultima="ultimaPagina" :total="guestsFiltrados.length" @ir="irAPagina" />
                </template>
            </section>
        </div>

        <!-- Confirmación -->
        <div v-if="modal" class="us-modal">
            <div class="us-modal-bg" @click="responderModal(false)"></div>
            <div ref="modalCard" class="us-modal-card" role="alertdialog" aria-modal="true" aria-labelledby="pa-m-title" aria-describedby="pa-m-text" @keydown="teclaModal">
                <h2 id="pa-m-title">{{ modal.titulo }}</h2>
                <p id="pa-m-text">{{ modal.texto }}</p>
                <div class="us-modal-btns">
                    <button type="button" class="bk-btn bk-btn--ghost" @click="responderModal(false)">{{ $t('admin_property.k.cancel') }}</button>
                    <button ref="modalOk" type="button" class="bk-btn us-btn--danger" @click="responderModal(true)">{{ modal.ok }}</button>
                </div>
            </div>
        </div>

        <transition name="us-toast">
            <div v-if="aviso" :class="['us-toast', `us-toast--${aviso.tipo}`]" role="status" aria-live="polite">
                <span class="us-toast-ico" aria-hidden="true">{{ aviso.tipo === 'ok' ? '✓' : '!' }}</span><span>{{ aviso.txt }}</span>
            </div>
        </transition>
    </div>
</template>

<script>
import axios from 'axios';
import BkPaginacion from '@/components/Cuenta/BkPaginacion.vue';
import HyFLoader from '@/components/Loader/HyFLoader.vue';
import ICON from '@/components/Cuenta/iconos';

const P = d => `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${d}</svg>`;
// Íconos: texto fijo de este archivo, nunca datos del usuario.
const IC = {
    back: P('<path d="M15 18l-6-6 6-6"/>'),
    ext: P('<path d="M14 4h6v6M20 4l-9 9M19 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h5"/>'),
    warn: P('<path d="M12 3 2 20h20z"/><path d="M12 10v4M12 17h.01"/>'),
    info: P('<circle cx="12" cy="12" r="9"/><path d="M12 11v5M12 8h.01"/>'),
    id: P('<rect x="3" y="5" width="18" height="14" rx="2.5"/><circle cx="9" cy="11" r="2"/><path d="M6 16a3 3 0 0 1 6 0M14 10h4M14 14h3"/>'),
    copy: ICON.copy, plus: ICON.plus, edit: ICON.edit, trash: ICON.trash, pin: ICON.pin, mail: ICON.mail, tel: ICON.tel, search: ICON.search, sync: ICON.sync,
};
const TABS = ['aloj', 'guests'];
const FILTROS = ['', 'sent', 'pending'];
const POR_PAGINA = 15;
const LOCALES = { es: 'es-CL', en: 'en-US', pt: 'pt-BR', fr: 'fr-FR', it: 'it-IT', de: 'de-DE' };
const CORREO = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

export default {
    name: 'PropertyAdmin',
    components: { BkPaginacion, HyFLoader },
    data() {
        return {
            IC, TABS, FILTROS,
            api: process.env.VUE_APP_API_URL,
            tab: 'aloj',
            cargado: false, errorCarga: false,
            items: [], guests: [],
            nuevo: { id: '', comuna: '', correo: '' }, lookup: null, buscando: false, guardando: false, errAdd: {},
            editId: null, edit: { comuna: '', correo: '' }, errEdit: {}, guardandoEdit: false,
            cambiando: null, cargandoGuests: false,
            q: '', filtro: '', pagina: 1,
            modal: null, aviso: null,
        };
    },
    computed: {
        loc() { return LOCALES[this.$i18n.locale] || 'es-CL'; },
        publicUrl() { return `${window.location.origin}/property-huesped`; },
        activos() { return this.items.filter(i => this.activo(i)).length; },
        enviados() { return this.guests.filter(g => this.enviado(g)).length; },
        guestsFiltrados() {
            const t = this.q.trim().toLowerCase();
            return this.guests.filter(g => {
                if (this.filtro === 'sent' && !this.enviado(g)) return false;
                if (this.filtro === 'pending' && this.enviado(g)) return false;
                if (!t) return true;
                return [g.nombre, g.apellido, g.rut_pasaporte, g.correo, g.telefono, g.numero].join(' ').toLowerCase().includes(t);
            });
        },
        ultimaPagina() { return Math.max(1, Math.ceil(this.guestsFiltrados.length / POR_PAGINA)); },
        guestsPagina() { return this.guestsFiltrados.slice((this.pagina - 1) * POR_PAGINA, this.pagina * POR_PAGINA); },
    },
    watch: {
        ultimaPagina(n) { if (this.pagina > n) this.pagina = n; },
    },
    created() {
        this._avisoT = null;
        this.cargarTodo();
    },
    beforeDestroy() { clearTimeout(this._avisoT); },
    methods: {
        // ── Datos ────────────────────────────────────────────────────────
        cargarTodo() {
            this.errorCarga = false;
            this.cargado = false;
            Promise.all([this.cargarItems(), this.cargarHuespedes()])
                .catch(e => { console.error('[Property] No se pudo cargar', e); this.errorCarga = true; })
                .finally(() => { this.cargado = true; });
        },
        cargarItems() {
            return axios.get(`${this.api}admin/property/accommodations`).then(r => { this.items = Array.isArray(r.data) ? r.data : []; });
        },
        cargarHuespedes() {
            return axios.get(`${this.api}admin/property/guests`).then(r => { this.guests = Array.isArray(r.data) ? r.data : []; });
        },
        refrescarHuespedes() {
            this.cargandoGuests = true;
            this.cargarHuespedes()
                .catch(() => this.avisar(this.$t('admin_property.toast.load'), 'error'))
                .finally(() => { this.cargandoGuests = false; });
        },

        // ── Formato ──────────────────────────────────────────────────────
        numero(n) { return Number(n || 0).toLocaleString(this.loc); },
        activo(it) { return Number(it.activo) === 1 || it.activo === true; },
        enviado(g) { return Number(g.correo_enviado) === 1; },
        huespedesDe(it) { return this.guests.filter(g => Number(g.property_alojamiento_idproperty_alojamiento) === Number(it.idproperty_alojamiento)).length; },
        iniciales(g) { return (`${(g.nombre || '?')[0]}${(g.apellido || '')[0] || ''}`).toUpperCase(); },
        fecha(s) {
            if (!s) return '—';
            const d = new Date(String(s).length === 10 ? `${s}T00:00:00` : String(s).slice(0, 19).replace(' ', 'T'));
            return isNaN(d.getTime()) ? s : d.toLocaleDateString(this.loc, { day: 'numeric', month: 'short', year: 'numeric' });
        },
        noches(g) {
            const a = new Date(`${g.fecha_ingreso}T00:00:00`), b = new Date(`${g.fecha_salida}T00:00:00`);
            return isNaN(a) || isNaN(b) ? 0 : Math.max(0, Math.round((b - a) / 864e5));
        },
        irAPagina(p) {
            this.pagina = p;
            this.$nextTick(() => { const el = this.$el.querySelector('.us-toolbar'); if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
        },
        async copiar(txt) {
            try { await navigator.clipboard.writeText(txt); this.avisar(this.$t('admin_property.copied'), 'ok'); } catch (e) { this.avisar(this.$t('admin_property.copy_fail'), 'error'); }
        },

        // ── Agregar ──────────────────────────────────────────────────────
        async buscar() {
            const id = this.nuevo.id;
            if (!id || this.buscando) return;
            this.buscando = true;
            this.lookup = null;
            try {
                const { data } = await axios.get(`${this.api}admin/property/accommodations/lookup/${id}`);
                this.lookup = { id, exists: !!data.exists, ya_configurado: !!data.ya_configurado, numero: data.numero || '', direccion: data.direccion || '' };
            } catch (e) {
                this.lookup = { id, exists: false, ya_configurado: false, numero: '', direccion: '' };
            } finally {
                this.buscando = false;
            }
            this.errAdd = {};
            if (this.lookup.exists && !this.lookup.ya_configurado) this.$nextTick(() => this.$refs.comunaIn && this.$refs.comunaIn.focus());
        },
        async agregar() {
            if (this.guardando) return;
            const e = {};
            if (!this.nuevo.comuna) e.comuna = this.$t('admin_property.add.err_comuna');
            if (!CORREO.test(this.nuevo.correo)) e.correo = this.$t('admin_property.add.err_mail');
            this.errAdd = e;
            if (Object.keys(e).length) return;
            this.guardando = true;
            try {
                await axios.post(`${this.api}admin/property/accommodations`, {
                    idalojamiento: this.lookup.id, comuna: this.nuevo.comuna, correo_notificacion: this.nuevo.correo,
                });
                this.avisar(this.$t('admin_property.toast.added', { id: this.lookup.id }), 'ok');
                this.nuevo = { id: '', comuna: '', correo: '' };
                this.lookup = null;
                await this.cargarItems();
            } catch (err) {
                const m = err.response && err.response.data && err.response.data.message;
                this.avisar(typeof m === 'string' ? m : this.$t('admin_property.toast.error'), 'error');
            } finally {
                this.guardando = false;
            }
        },

        // ── Editar / activar / quitar ────────────────────────────────────
        empezarEdicion(it) {
            this.editId = it.idproperty_alojamiento;
            this.edit = { comuna: it.comuna || '', correo: it.correo_notificacion || '' };
            this.errEdit = {};
            this.$nextTick(() => { const el = this.$refs.editIn; (Array.isArray(el) ? el[0] : el) && (Array.isArray(el) ? el[0] : el).focus(); });
        },
        cancelarEdicion() {
            const id = this.editId;
            this.editId = null;
            this.$nextTick(() => {
                const li = this.$el.querySelector(`.pa-item[data-id="${id}"]`);
                if (li) { const b = li.querySelector('.pa-item-actions .bk-btn'); if (b) b.focus(); }
            });
        },
        async guardarEdicion(it) {
            if (this.guardandoEdit) return;
            const e = {};
            if (!this.edit.comuna) e.comuna = this.$t('admin_property.add.err_comuna');
            if (!CORREO.test(this.edit.correo)) e.correo = this.$t('admin_property.add.err_mail');
            this.errEdit = e;
            if (Object.keys(e).length) return;
            this.guardandoEdit = true;
            try {
                // Igual que antes: comuna, correo y el estado actual.
                await axios.put(`${this.api}admin/property/accommodations/${it.idproperty_alojamiento}`, {
                    comuna: this.edit.comuna, correo_notificacion: this.edit.correo, activo: this.activo(it) ? 1 : 0,
                });
                this.editId = null;
                this.avisar(this.$t('admin_property.toast.saved'), 'ok');
                await this.cargarItems();
            } catch (err) {
                const m = err.response && err.response.data && err.response.data.message;
                this.avisar(typeof m === 'string' ? m : this.$t('admin_property.toast.error'), 'error');
            } finally {
                this.guardandoEdit = false;
            }
        },
        async alternar(it) {
            if (this.cambiando) return;
            const nuevo = !this.activo(it);
            this.cambiando = it.idproperty_alojamiento;
            try {
                await axios.put(`${this.api}admin/property/accommodations/${it.idproperty_alojamiento}`, { activo: nuevo ? 1 : 0 });
                it.activo = nuevo ? 1 : 0;
                this.avisar(this.$t(nuevo ? 'admin_property.toast.on' : 'admin_property.toast.off'), 'ok');
            } catch (e) {
                this.avisar(this.$t('admin_property.toast.error'), 'error');
            } finally {
                this.cambiando = null;
            }
        },
        async quitar(it) {
            const ok = await this.confirmar({
                titulo: this.$t('admin_property.k.del_t'),
                texto: this.$t('admin_property.k.del_p', { n: it.numero ? `${it.numero} (#${it.alojamiento_idalojamiento})` : `#${it.alojamiento_idalojamiento}` }),
                ok: this.$t('admin_property.k.del_ok'),
            });
            if (!ok) return;
            try {
                await axios.delete(`${this.api}admin/property/accommodations/${it.idproperty_alojamiento}`);
                this.avisar(this.$t('admin_property.toast.deleted'), 'ok');
                await this.cargarItems();
            } catch (e) {
                this.avisar(this.$t('admin_property.toast.error'), 'error');
            }
        },

        // ── Confirmación y aviso ─────────────────────────────────────────
        confirmar({ titulo, texto, ok }) {
            return new Promise(resolve => {
                this._modalFoco = document.activeElement;
                this.modal = { titulo, texto, ok, resolve };
                this.$nextTick(() => { if (this.$refs.modalOk) this.$refs.modalOk.focus(); });
            });
        },
        responderModal(v) {
            if (!this.modal) return;
            const { resolve } = this.modal;
            this.modal = null;
            const el = this._modalFoco;
            this.$nextTick(() => { if (el && document.contains(el)) el.focus(); });
            resolve(v);
        },
        teclaModal(e) {
            if (e.key === 'Escape') { e.preventDefault(); this.responderModal(false); return; }
            if (e.key !== 'Tab') return;
            const els = Array.from(this.$refs.modalCard.querySelectorAll('button'));
            const first = els[0], last = els[els.length - 1];
            if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
            else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        },
        avisar(txt, tipo) {
            clearTimeout(this._avisoT);
            this.aviso = { txt, tipo: tipo || 'ok' };
            this._avisoT = setTimeout(() => { this.aviso = null; }, 3200);
        },
    },
};
</script>

<style src="../../BankInformation/bkCuenta.css"></style>
<style src="../../Cuenta/cuentaMenu.css"></style>
<style src="../Usuarios/usuariosAdmin.css"></style>
<style src="./propertyAdmin.css"></style>
